import { jsx as _jsx } from "react/jsx-runtime";
import { LiteralBase, getLiteralBaseProps, baseEditableOptions } from "./TextLiteral";
import { useFormattedParts } from "./NumberLiteral";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import { removeNegativeZero } from "../../utils";
export const PercentLiteral = ({ emptyEqualsZero, formatString, ...rest }) => {
    const { suffix: suffixValue = undefined, prefix: prefixValue = undefined } = rest;
    const { prefix = prefixValue, str, suffix = suffixValue } = useFormattedParts(removeNegativeZero(rest.field.value) / 100, {
        format: "percent_input"
    }, emptyEqualsZero, formatString);
    return (_jsx(LiteralBase, { ...getLiteralBaseProps(rest), prefix: prefix, suffix: suffix, children: str }));
};
export const EditorPercentLiterals = identityRecordOfFieldEditorOptions({
    PercentLiteral: {
        editableOptions: {
            ...baseEditableOptions,
            prefix: true,
            suffix: true
        }
    }
});
//# sourceMappingURL=PercentLiteral.js.map